import React from 'react';
import LinkLocale from '../Route/Link/index.js';
import styles from './styles.scss.js';

const Menu = ({ className, list }) => (React.createElement("div", { className: className }, list.map(({ active, href, label, badge }) => (React.createElement(LinkLocale, { key: label, className: active ? styles.activeLink : styles.link, href: href, color: "neutral", title: label },
    label,
    badge && React.createElement("span", { className: styles.notification }))))));

export { Menu as default };
//# sourceMappingURL=index.js.map
